import { formatUsdtAmount } from '@/utils/format'

/** TRC20 USDT (Tron mainnet) */
export const USDT_TRC20_CONTRACT = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t'
const TRONGRID_ACCOUNTS_API = 'https://api.trongrid.io/v1/accounts'
const USDT_DECIMALS = 6

export function isValidTronAddress (address) {
  const trimmed = String(address || '').trim()
  return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(trimmed)
}

function parseUsdtFromAccountRow (row) {
  if (!row || !Array.isArray(row.trc20)) return 0
  for (let i = 0; i < row.trc20.length; i++) {
    const entry = row.trc20[i]
    if (!entry) continue
    const raw = entry[USDT_TRC20_CONTRACT]
    if (raw == null || raw === '') continue
    const value = Number(raw)
    if (!Number.isFinite(value)) continue
    return value / Math.pow(10, USDT_DECIMALS)
  }
  return 0
}

/**
 * TronGrid 공용 API로 TRC20 USDT 보유량 조회 (백엔드 미사용)
 * @returns {Promise<number>} USDT 수량
 */
export async function fetchTrc20UsdtBalance (address) {
  const wallet = String(address || '').trim()
  if (!isValidTronAddress(wallet)) {
    throw new Error('올바른 TRC20 지갑 주소를 입력해 주세요.')
  }

  const url = `${TRONGRID_ACCOUNTS_API}/${encodeURIComponent(wallet)}`
  let res
  try {
    res = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' }
    })
  } catch (err) {
    throw new Error('지갑 잔액 조회에 실패했습니다. 네트워크 연결을 확인해 주세요.')
  }

  if (!res.ok) {
    throw new Error('지갑 잔액 조회에 실패했습니다.')
  }

  const body = await res.json()
  if (!body || body.success === false) {
    throw new Error('지갑 잔액 조회에 실패했습니다.')
  }

  const row = body.data && body.data.length ? body.data[0] : null
  return parseUsdtFromAccountRow(row)
}

export function formatTrc20UsdtBalance (balance) {
  return formatUsdtAmount(balance, { maxDecimals: 2, minDecimals: 2 })
}
